<template>
  <div class="riskCount-wrap">
    <img
      :src="require(`@/assets/images/largeScreen/${props.item.bg}.png`)"
      alt=""
    />
    <div class="riskCount-content">
      <div class="riskCount-titile">{{ props.item.title }}</div>
      <div class="riskCount-count">
        <!-- {{ props.data || 0 }} -->
        <CountUp
          :startVal="0"
          :endVal="props.data ? props.data : 0"
          :index="`riskCount_num`"
        />
      </div>
      <div class="riskCount-list">
        <div
          v-for="item in LEVELLIST"
          :key="item.value"
          :style="{ width: `${100 / LEVELLIST.length}%` }"
          class="riskCount-item"
        >
          <img
            :src="require(`@/assets/images/largeScreen/${item.fileName}.png`)"
            alt=""
          />
          <div class="riskCount-item-title">{{ item.title }}</div>
          <div class="riskCount-item-num" :style="{ color: `${item.color}` }">
            <!-- {{ levelData ? levelData[item.key] : 0 }} -->
            <CountUp
              :startVal="0"
              :endVal="props.levelData ? props.levelData[item.key] : 0"
              :index="`riskCount_list_${item.key}`"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountUp from "@/components/common/countup.vue";

export default {
  props: {
    data: Object,
    item: Object,
    levelData: Object
  },
  components: {
    CountUp,
  },
  setup(props) {
    const LEVELLIST = [
      {
        title: '高风险',
        fileName: 'vivo',
        key: 'high',
        color: "#F8517D"
      },
      {
        title: '中风险',
        fileName: 'vivo1',
        key: 'middle',
        color: "#F96"
      },
      {
        title: '低风险',
        fileName: 'vivo2',
        key: 'low',
        color: "#FFBF66"
      },
    ];
    return {
      props,
      LEVELLIST
    };
  }
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
